<button #openDrawerButton command="show-modal" commandfor="drawer"
    class="sr-only rounded-md bg-gray-950/5 px-2.5 py-1.5 text-sm font-semibold text-primary hover:bg-gray-950/10">Open
    drawer</button>
<el-dialog>
    <dialog #drawerDialog id="drawer" aria-labelledby="drawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto bg-white shadow-xl rounded-xl">


                    <!-- header -->
                    <!-- <div class="bg-indigo-700 px-2 py-4"> -->
                    <div class="px-2 py-4 drawer-header-primary">
                        <div class="flex space-x-3 h-full items-center">
                            <div class="min-w-0 flex-1 px-2">
                                <p class="text-md font-semibold text-primary">
                                    Promote to Brief
                                </p>
                                <p class="text-sm text-secondary">
                                    Select the brief to which you would like to
                                    promote the selected creators.
                                </p>
                            </div>

                            <div class="h-full flex flex-col justify-between items-end">

                                <button type="button" (click)="closeDrawer()"
                                    class="btn-fab-secondary text-secondary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path d="M18 6 6 18" />
                                        <path d="m6 6 12 12" />
                                    </svg>
                                </button>

                            </div>
                        </div>
                    </div>
                    <!-- header - END -->

                    <!-- main content -->
                    <div
                        class="relative px-4 py-4 h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary space-y-8">

                        <!-- Campaigns -->
                        <div class="flex flex-col">
                            @if (allCampaigns()) {
                            <label for="select" class="block text-sm/6 font-medium text-primary">Select Campaign</label>
                            <el-select id="select" name="selected" class="mt-2 block">
                                <button type="button"
                                    class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                                    <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                        @if (selectedCampaign()) {
                                        <img [src]="selectedCampaign()?.campaignPhoto ? imageService.getImageSource(selectedCampaign()?.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                                            alt="Campaign Manager Photo"
                                            class="size-5 shrink-0 rounded-full dark:bg-gray-700 bg-gray-300 outline -outline-offset-1 outline-white/10" />
                                        <span class="block truncate">{{ selectedCampaign()?.campaignName }}</span>
                                        } @else {
                                        <div
                                            class="size-5 shrink-0 rounded-full outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path
                                                    d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
                                            </svg>
                                        </div>
                                        <span class="block truncate">All Campaigns</span>
                                        }

                                    </el-selectedcontent>
                                    <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-400 sm:size-4">
                                        <path
                                            d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </button>

                                <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                                    <el-option value="0" (click)="selectCampaign(undefined)"
                                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                        <div class="flex items-center">
                                            <div class="size-5 shrink-0 rounded-full">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="size-5">
                                                    <path
                                                        d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
                                                </svg>
                                            </div>
                                            <span
                                                class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                                All Campaigns</span>
                                        </div>
                                        <span
                                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                aria-hidden="true" class="size-5">
                                                <path
                                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </el-option>
                                    @for (campaign of allCampaigns(); track $index) {
                                    <el-option [value]="$index" (click)="selectCampaign(campaign)"
                                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                        <div class="flex items-center">
                                            <img class="size-5 shrink-0 rounded-full"
                                                [src]="campaign.campaignPhoto ? imageService.getImageSource(campaign.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                                                alt />
                                            <span
                                                class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                                {{ campaign.campaignName }}</span>
                                        </div>
                                        <span
                                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                aria-hidden="true" class="size-5">
                                                <path
                                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </el-option>
                                    }
                                </el-options>
                            </el-select>
                            }
                        </div>
                        <!-- Campaigns END -->


                        <!-- Linked Briefs -->
                        <div class="flex flex-col">
                            @if (linkedBriefs()) {
                            <label for="select" class="block text-sm/6 font-medium text-primary">Select Brief</label>
                            <el-select id="select" name="selected" class="mt-2 block">
                                <button type="button"
                                    class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                                    <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                        @if (selectedBrief()) {
                                        <span class="block truncate">{{ selectedBrief()?.title }}</span>
                                        } @else {
                                        <div
                                            class="size-5 shrink-0 rounded-full outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path
                                                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                                <path d="m9 15 2 2 4-4" />
                                            </svg>
                                        </div>
                                        <span class="block truncate">Campaign Briefs</span>
                                        }

                                    </el-selectedcontent>
                                    <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-400 sm:size-4">
                                        <path
                                            d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </button>

                                <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                                    <el-option value="0" (click)="selectBrief(undefined)"
                                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                        <div class="flex items-center">
                                            <div class="size-5 shrink-0 rounded-full">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="size-5">
                                                    <path
                                                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                                    <path d="m9 15 2 2 4-4" />
                                                </svg>
                                            </div>
                                            <span
                                                class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                                Campaign Briefs</span>
                                        </div>
                                        <span
                                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                aria-hidden="true" class="size-5">
                                                <path
                                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </el-option>
                                    @for (brief of linkedBriefs(); track $index) {
                                    <el-option [value]="$index" (click)="selectBrief(brief)"
                                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary focus:outline-hidden">
                                        <div class="flex items-center">
                                            <span
                                                class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">
                                                {{ brief.title }}</span>
                                        </div>
                                        <span
                                            class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary in-[el-selectedcontent]:hidden">
                                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                aria-hidden="true" class="size-5">
                                                <path
                                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </el-option>
                                    }
                                </el-options>
                            </el-select>
                            }
                        </div>
                        <!-- Linked Briefs END -->

                        <!-- Selected Creators -->
                        <div>
                            <label id="listbox-label" class="block text-sm font-medium text-primary">Selected
                                Creators</label>
                            <div>
                                @if (briefService.creatorsToPromote() &&
                                briefService.creatorsToPromote().length > 0) {
                                <ul role="list" class="divide-y divide-gray-200 dark:divide-zinc-700">
                                    @for (applicant of briefService.creatorsToPromote(); track applicant.id) {
                                    <li class="flex items-center justify-between gap-x-6 py-3">
                                        <div class="flex min-w-0 gap-x-4">
                                            <img class="size-10 flex-none rounded-full bg-gray-50"
                                                [src]="imageService.getImageSource(applicant.creator?.photoURL, 'gallery')"
                                                alt="">
                                            <div class="min-w-0 flex-auto">
                                                <p class="text-sm font-semibold text-primary">{{
                                                    applicant.creator?.firstName }} {{
                                                    applicant.creator?.lastName?.charAt(0)
                                                    }}.</p>
                                                <p class="truncate text-xs/5 text-secondary">
                                                    {{ applicant.creator?.email }}</p>
                                            </div>
                                        </div>
                                        <button type="button" (click)="removeCreator(applicant)"
                                            class="rounded-full bg-transparent p-2 text-red-500 hover:bg-red-100">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                            </svg>

                                        </button>
                                    </li>
                                    }
                                </ul>
                                } @else {
                                <p class="text-sm text-gray-500">No creators selected</p>
                                }
                            </div>

                        </div>
                        <!-- Selected Creators - END -->
                    </div>
                    <!-- main content - END -->

                    <!-- footer -->
                    <div class="px-4 py-4 drawer-header-primary flex flex-row items-center justify-end gap-x-4">
                        @if (runningPromote()) {
                        <svg aria-hidden="true"
                            class="mx-auto w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        } @else {
                        <button type="button" (click)="closeDrawer()"
                            class="text-secondary secondary-button">Cancel</button>
                        <button type="button" (click)="promoteCreators()"
                            class="primary-button">Promote</button>
                        }
                    </div>
                    <!-- footer - END -->
                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>